export default __webpack_public_path__ + "static/media/23.9c38292f.jpg";